// External packages
import { useController, useFormContext } from 'react-hook-form';
import * as React from 'react';

// Components
import { ButtonIcon } from 'components/Button';
import { Label } from 'components/Forms';
import { Icon } from 'components/Icons';

type WorkingHour = {
  startTime: string;
  endTime: string;
};

interface WorkingHoursInputProps {
  value: WorkingHour;
  onChange: (value: WorkingHour) => void;
  onRemove?: () => void;
  showRemove?: boolean;
}

export const WorkingHoursInput: React.FC<WorkingHoursInputProps> = ({
  value,
  onChange,
  onRemove,
  showRemove = false,
}) => {
  return (
    <div className="flex items-center gap-2">
      <p>Od:</p>
      <input
        type="time"
        value={value.startTime}
        onChange={(e) => onChange({ ...value, startTime: e.target.value })}
        className="border rounded px-2 py-1"
      />
      <p>Do:</p>
      <input
        type="time"
        value={value.endTime}
        onChange={(e) => onChange({ ...value, endTime: e.target.value })}
        className="border rounded px-2 py-1"
      />
      {showRemove && onRemove && (
        <ButtonIcon variant="ghost" colorScheme="tertiary" onPress={onRemove}>
          <Icon name="trash" className="size-5" />
        </ButtonIcon>
      )}
    </div>
  );
};

/* WorkingHoursField */

interface WorkingHoursFieldProps {
  name: string;
  label?: string;
  showRemove?: boolean;
  onRemove?: () => void;
  className?: string;
}

export const WorkingHoursField: React.FC<WorkingHoursFieldProps> = ({
  name,
  label,
  showRemove,
  onRemove,
  className,
}) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController<
    {
      [key: string]: WorkingHour;
    },
    string
  >({
    name,
    control,
  });

  return (
    <div className={className}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <WorkingHoursInput
        value={field.value || { startTime: '', endTime: '' }}
        onChange={field.onChange}
        showRemove={showRemove}
        onRemove={onRemove}
      />
      {error && (
        <div className="text-sm text-red-500 mt-1">{error.message}</div>
      )}
    </div>
  );
};
